import { render, staticRenderFns } from "./Public.CO.UK.vue?vue&type=template&id=eaa3bbd6"
import script from "./Public.CO.UK.vue?vue&type=script&lang=js"
export * from "./Public.CO.UK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
installComponents(component, {
  VApp,
  VNavigationDrawer,
})
